import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "header-cell__content"
}
const _hoisted_3 = { class: "table__header-cell--text" }
const _hoisted_4 = {
  key: 2,
  class: "resizer__container"
}

import { i18n } from '@/i18n';
import { ResizeStateService } from '../services/resizeStateService';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'TableHead',
  props: {
    index: {},
    label: { default: '' },
    textAlign: { default: 'center' },
    resizable: { type: Boolean, default: false },
    toolTipValue: { default: '' }
  },
  emits: ["onHover", "onLeave", "onClick", "onMousedownResizer"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "9e49786a": (_ctx.textAlign)
}))

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("th", {
    id: _unref(ResizeStateService).getTableHeaderId(_ctx.index),
    class: "header-cell",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (emits('onHover'))),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (emits('onLeave'))),
    onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('onClick')))
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(props.label)), 1),
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }),
    (_ctx.resizable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "resizer__item",
            onMousedown: _cache[0] || (_cache[0] = ($event: any) => (emits('onMousedownResizer', $event)))
          }, null, 32)
        ]))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1)), [
    [
      _directive_tooltip,
      props.toolTipValue,
      void 0,
      { bottom: true }
    ]
  ])
}
}

})